import { render, staticRenderFns } from "./ModalUpload.vue?vue&type=template&id=67debae0&"
import script from "./ModalUpload.vue?vue&type=script&lang=js&"
export * from "./ModalUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports